$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  if ($('#cardWidgetTwo .buttonwrap a').length === 0) {
    // If there's no link, change the hover styles
    $('#cardWidgetTwo .buttonwrap a').hover(function() {
      // Add your hover styles here
      $(this).css('display', 'none');
    }, function() {
      // Restore the original styles
      $(this).css('display', 'flex');
    });
  }

  if (window.location.href.endsWith('/businesses')) {
    $('h1').hide();
  }
});

$(window).load(function () {
  // ---

  $('#siteInfoBannerWidget #eventName').insertAfter('#cardWidgetTimes').show();

   // Weather Bug
   setInterval(function() {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if(!weatherBugSet && str != ''){
      $('#weatherBugWidget').addClass('weatherBugSet');
        var findSpace = str.lastIndexOf(' ');
        var stringLength = str.length;
        var res = str.substring(findSpace, stringLength);
        var start = str.substring(0, findSpace);
        $('#weatherBugDescription').html('<span class="weatherDescriptive">'+start+'</span>'+res);
        $('#weatherBugWidget').css('visibility', 'visible');
    }
  },12);

});